// extracted by mini-css-extract-plugin
export var growableInput = "_9m-0";
export var tagContainer = "_9m-2";
export var textInput = "_9m-1";